import { ChalkboardTeacher } from "@phosphor-icons/react";
import { fileUrl } from "../../lib/api";
import { useLang } from "../../i18n";
import Chapter from "./Chapter";
import Reveal from "./Reveal";
import ScrollStrip from "./ScrollStrip";

export default function Coach({ coaches }) {
    const { t } = useLang();

    return (
        <section id="coach" className="py-24 md:py-32 border-t border-racing-line" data-testid="coach-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <Chapter number="05" title={t.ch_coach_t} subtitle={t.ch_coach_s} />

                {coaches.length === 0 ? (
                    <p className="text-racing-muted" data-testid="coach-empty">{t.coach_empty}</p>
                ) : (
                    <ScrollStrip testid="coach-strip" gapClass="gap-6">
                        {coaches.map((c, i) => (
                            <Reveal key={c.id} delay={i * 0.1} className={`shrink-0 snap-start ${coaches.length > 1 ? "w-full md:w-[80%] lg:w-[64%]" : "w-full"}`}>
                                <article data-testid={`coach-card-${i}`} className="group relative h-full bg-racing-surface overflow-hidden border border-racing-line">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 h-full">
                                        <div className="relative h-72 sm:h-auto sm:min-h-[320px] overflow-hidden">
                                            {c.photo_url ? (
                                                <img
                                                    src={fileUrl(c.photo_url)}
                                                    alt={c.name}
                                                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-all duration-700"
                                                />
                                            ) : (
                                                <div className="absolute inset-0 flex items-center justify-center bg-[#F1ECE3]">
                                                    <ChalkboardTeacher size={72} weight="duotone" className="text-black/10" />
                                                </div>
                                            )}
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                                        </div>
                                        <div className="p-8 md:p-10 flex flex-col justify-center">
                                            <span className="font-display uppercase text-[#FFB800] text-3xl md:text-5xl leading-[0.95]" data-testid={`coach-role-${i}`}>
                                                {c.role}
                                            </span>
                                            <h3 className="mt-5 font-display uppercase text-3xl md:text-4xl text-neutral-900 leading-none" data-testid={`coach-name-${i}`}>
                                                &ldquo;{c.name}&rdquo;
                                            </h3>
                                            <p className="mt-5 text-sm md:text-base font-light text-racing-muted leading-relaxed">
                                                {c.description}
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </Reveal>
                        ))}
                    </ScrollStrip>
                )}
            </div>
        </section>
    );
}
